import styled from 'styled-components'

export const MainContainer = styled.div`
  margin-top: 44px;
  margin-left: 44px;
  margin-right: 44px;
  margin-bottom: 62px;
`

export const Loading = styled.div`
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
`
